/**
 * Scroll spy for sections/scroll-spy-anchor.liquid only.
 * Does not modify theme.js ScrollSpy used by sections/scroll-spy.liquid.
 *
 * Targets match an element id, data-anchor-id, or data-collection-name.
 * Click locks the active item until scrollend so intermediate sections do not flash.
 */
(function () {
  var FOCUS_LINE = 200;

  function normalizeId(id) {
    return String(id || '')
      .replace(/#/g, '')
      .trim();
  }

  function escapeAttr(id) {
    if (window.CSS && CSS.escape) return CSS.escape(id);
    return id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function findTarget(id) {
    if (!id) return null;
    var byId = document.getElementById(id);
    if (byId) return byId;
    var escaped = escapeAttr(id);
    return (
      document.querySelector('[data-anchor-id="' + escaped + '"]') ||
      document.querySelector('[data-collection-name="' + escaped + '"]')
    );
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function startCountdowns(root) {
    var nodes = Array.from(root.querySelectorAll('[data-ssa-countdown]'));
    if (!nodes.length) return 0;

    var tick = function () {
      var now = Date.now();
      nodes.forEach(function (node) {
        var end = Number(node.getAttribute('data-end')) * 1000;
        if (!Number.isFinite(end)) return;
        var remaining = Math.max(0, end - now);
        var days = node.querySelector('[data-days]');
        var hours = node.querySelector('[data-hours]');
        var minutes = node.querySelector('[data-minutes]');
        var seconds = node.querySelector('[data-seconds]');
        if (days) days.textContent = pad(Math.floor(remaining / 86400000));
        if (hours) hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
        if (minutes) minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
        if (seconds) seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
      });
    };

    tick();
    return window.setInterval(tick, 1000);
  }

  function prefersReducedMotion() {
    return Boolean(window.theme && theme.config && theme.config.motionReduced);
  }

  function boxTop(target) {
    var section = target.closest('.shopify-section') || target;
    return window.scrollY + section.getBoundingClientRect().top;
  }

  function scrollTopForLine(docTop, line) {
    return Math.max(0, docTop - line);
  }

  function activeId(entries, probe) {
    var current = entries.length ? entries[0].id : '';
    entries.forEach(function (entry) {
      if (probe >= entry.top - 1) current = entry.id;
    });
    return current;
  }

  function assertScrollLine() {
    var chrome = 116;
    var line = chrome + FOCUS_LINE;
    var y = scrollTopForLine(2000, line);
    var probe = y + line;
    var id = activeId(
      [
        { id: 'short', top: 2000 },
        { id: 'next', top: 2400 }
      ],
      probe
    );
    if (y !== 2000 - line || probe !== 2000 || 2000 - (y + chrome) !== FOCUS_LINE || id !== 'short') {
      throw new Error('ssa line');
    }
  }

  assertScrollLine();

  if (typeof customElements === 'undefined') return;

  class ScrollSpyAnchor extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('.scrollspy-link'));
      this.root = this.closest('.scroll-spy-anchor') || this;
      this.ctas = Array.from(this.root.querySelectorAll('[data-ssa-cta]'));
      this.lockId = '';
      this.lockToken = 0;
      this.acceptEnd = false;
      this.shownId = '';
      this.lockTimer = 0;
      this.countdownTimer = 0;
      this.onClick = this.handleClick.bind(this);
      this.onBackToTopClick = this.handleBackToTopClick.bind(this);
      this.onScroll = this.updateActive.bind(this);
      this.onScrollEnd = this.handleScrollEnd.bind(this);

      this.links.forEach(function (link) {
        link.addEventListener('click', this.onClick);
      }, this);
      this.ctas.forEach(function (cta) {
        cta.addEventListener('click', this.onClick);
      }, this);

      var backToTop = this.querySelector('.back-to-top');
      if (backToTop) backToTop.addEventListener('click', this.onBackToTopClick);

      this.countdownTimer = startCountdowns(this.root);

      if (this.showHighlight) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('scrollend', this.onScrollEnd);
        this.updateActive();
      }
    }

    disconnectedCallback() {
      this.links.forEach(function (link) {
        link.removeEventListener('click', this.onClick);
      }, this);
      this.ctas.forEach(function (cta) {
        cta.removeEventListener('click', this.onClick);
      }, this);

      var backToTop = this.querySelector('.back-to-top');
      if (backToTop) backToTop.removeEventListener('click', this.onBackToTopClick);

      if (this.countdownTimer) window.clearInterval(this.countdownTimer);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('scrollend', this.onScrollEnd);
      if (this.lockTimer) window.clearTimeout(this.lockTimer);
    }

    get showHighlight() {
      return this.hasAttribute('data-highlight');
    }

    focusLine() {
      var section = this.closest('.shopify-section');
      var barHeight = section ? section.offsetHeight : 0;
      var header = document.querySelector('.header-section header[is="sticky-header"]');
      var headerHeight = 0;
      if (header) headerHeight = Math.max(0, header.getBoundingClientRect().bottom);
      return headerHeight + barHeight + FOCUS_LINE;
    }

    handleClick(event) {
      var link = event.currentTarget;
      var firstId = normalizeId((link.getAttribute('data-target') || '').split(',')[0]);
      var target = findTarget(firstId);
      if (!target) return;

      event.preventDefault();
      var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      if (this.showHighlight) this.lockTo(firstId);
      window.scrollTo({
        top: scrollTopForLine(boxTop(target), this.focusLine()),
        behavior: behavior
      });
      if (behavior === 'auto' && this.showHighlight) this.releaseLock();
    }

    handleBackToTopClick() {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    lockTo(id) {
      var token = ++this.lockToken;
      this.lockId = id;
      this.acceptEnd = false;
      this.shownId = '';
      this.setActive(id);
      if (this.lockTimer) window.clearTimeout(this.lockTimer);
      // ponytail: scrollend is the real release; this only covers browsers that never fire it
      this.lockTimer = window.setTimeout(function () {
        if (this.lockToken === token) this.releaseLock();
      }.bind(this), 4000);
      requestAnimationFrame(function () {
        if (this.lockToken === token) this.acceptEnd = true;
      }.bind(this));
    }

    handleScrollEnd(event) {
      if (!this.lockId || !this.acceptEnd) return;
      var target = event.target;
      if (target && target !== document && target !== document.scrollingElement) return;
      this.releaseLock();
    }

    releaseLock() {
      this.lockId = '';
      this.acceptEnd = false;
      if (this.lockTimer) {
        window.clearTimeout(this.lockTimer);
        this.lockTimer = 0;
      }
      this.updateActive();
    }

    updateActive() {
      if (this.lockId) return;

      var probe = window.scrollY + this.focusLine();
      var entries = [];

      this.links.forEach(function (link) {
        (link.getAttribute('data-target') || '').split(',').forEach(function (raw) {
          var id = normalizeId(raw);
          var target = findTarget(id);
          if (!target) return;
          entries.push({ id: id, top: boxTop(target) });
        });
      });

      entries.sort(function (a, b) {
        return a.top - b.top;
      });
      this.setActive(activeId(entries, probe));
    }

    setActive(current) {
      var activeLink = null;
      this.links.forEach(function (link) {
        var ids = (link.getAttribute('data-target') || '').split(',').map(normalizeId);
        var active = current !== '' && ids.indexOf(current) !== -1;
        link.classList.toggle('active', active);
        if (active) {
          activeLink = link;
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (current === this.shownId) return;
      this.shownId = current;
      this.revealActive(activeLink);
    }

    revealActive(link) {
      if (!link) return;
      var item = link.closest('li') || link;
      var list = this;
      var fade = 24;
      var listRect = list.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      if (itemRect.left >= listRect.left + fade && itemRect.right <= listRect.right - fade) return;
      var delta = itemRect.left - listRect.left - (list.clientWidth - itemRect.width) / 2;
      list.scrollTo({
        left: Math.max(0, list.scrollLeft + delta),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }
  }

  if (!customElements.get('scroll-spy-anchor')) {
    customElements.define('scroll-spy-anchor', ScrollSpyAnchor, { extends: 'nav' });
  }
})();
